import { AnyAction } from '@reduxjs/toolkit';
import { get } from 'lodash';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { notify } from '../../../common/utils/notify';
import api from '../../apiServices';
import { UserDTO } from '../../types/apiType';
import { setLoading } from '../common/CommonSlice';
import { UserActions } from './UserActions';
import UserCognitoService from './UserCognitoService';
import { setAuthorizedBooks, setAuthorizedUsers, setCurrentUser } from './UserSlice';
import { BookRole } from '../../../common/enum';

function* getListSaga(action: AnyAction): any {
  const isLoading = !action.payload;
  try {
    if (isLoading) {
      yield put(setLoading(true));
    }
    const { users, books } = yield call(api.user.lists);
    yield put(setAuthorizedUsers(users));
    yield put(setAuthorizedBooks(books));
  } catch (error) {
    const message = get(error, 'message');
    if (message) {
      notify.error(message);
    }
  } finally {
    if (isLoading) {
      yield put(setLoading(false));
    }
  }
}

function* getInfoSaga(_: AnyAction): any {
  try {
    // yield put(setLoading(true));
    const data = yield call(UserCognitoService.getUserAttributes);
    yield put(setCurrentUser(data as UserDTO));
    // yield put(setLoading(false));
  } catch (error) {
    console.log(error);
  } finally {
    // yield put(setLoading(false));
  }
}

export function* userSaga() {
  yield all([takeLatest(UserActions.getList, getListSaga), takeLatest(UserActions.getInfo, getInfoSaga)]);
}
